import { createContext, useContext } from 'react';

import type { DropdownOption } from '../../dropdown/types';
import { 
	useAccordionDropdown, 
	AccordionGroupOption, 
	UseAccordionDropdownProps
} from '../hooks/use-accordion-dropdown';

interface AccordionDropdownContextType extends Omit<UseAccordionDropdownProps, 'valueTemplate' | 'onChange'> {
	isMenuOpen: boolean;
	toggleMenuOpen: () => void;
	closeMenu: () => void;
	createTriggerLabel: () => React.ReactNode;
	getSelectedOption: () => {
		selectedGroup: AccordionGroupOption | undefined;
		selectedItem: DropdownOption | undefined;
	};
	getOptionProps: (
		groupOption: AccordionGroupOption, 
		itemOption: DropdownOption, 
		props?: Record<string, any>
	) => Record<string, any>;
}

interface AccordionDropdownProviderProps extends UseAccordionDropdownProps {
	children: React.ReactNode;
}

const AccordionDropdownContext = createContext<AccordionDropdownContextType>({} as AccordionDropdownContextType);

export function AccordionDropdownProvider({ children, ...props }: AccordionDropdownProviderProps) {
	const valueProps = useAccordionDropdown(props);

	return (
		<AccordionDropdownContext.Provider value={valueProps}>
			{children}
		</AccordionDropdownContext.Provider>
	);
}

export const useAccordionDropdownContext = () => useContext(AccordionDropdownContext);